import type { GQUserItem } from "@/admin/users/UsersTable.tsx";
import { WModalButton } from "@/components/button/WToolButton.tsx";
import { WModal } from "@/components/modal/WModal.tsx";
import { useStartAdminImpersonation } from "@/modules/access/impersonation/accessImpersonationApi.ts";
import { ActAsModalCommon } from "@/modules/user/ActAsModal.tsx";

interface ImpersonateModalModalProps {
    item: Pick<GQUserItem, "id" | "name">;
}

export function ImpersonateModalContent({ item }: ImpersonateModalModalProps) {
    const startImpersonation = useStartAdminImpersonation();
    const { id, name } = item;

    return (
        <ActAsModalCommon
            name={name}
            action={async () => {
                await startImpersonation.mutateAsync({
                    body: {
                        target_user_id: Number(id),
                        description: "For impersonating user",
                        is_admin: true,
                    },
                    access_owner: name,
                });
            }}
        />
    );
}

export function ImpersonateBlock(props: ImpersonateModalModalProps) {
    return (
        <WModal button={<WModalButton inTable label="Impersonate" size="xs" icon="jp-swap-icon" />}>
            <ImpersonateModalContent {...props} />
        </WModal>
    );
}
